/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsCommunityFundTotalStakedFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsCommunityFundTotalStakedFormat = ClosedEnum<
  typeof GetApiV3MetricsCommunityFundTotalStakedFormat
>;

export type GetApiV3MetricsCommunityFundTotalStakedRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsCommunityFundTotalStakedFormat | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsCommunityFundTotalStakedFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsCommunityFundTotalStakedFormat> = z
    .nativeEnum(GetApiV3MetricsCommunityFundTotalStakedFormat);

/** @internal */
export const GetApiV3MetricsCommunityFundTotalStakedFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsCommunityFundTotalStakedFormat> =
    GetApiV3MetricsCommunityFundTotalStakedFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsCommunityFundTotalStakedFormat$ {
  /** @deprecated use `GetApiV3MetricsCommunityFundTotalStakedFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsCommunityFundTotalStakedFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsCommunityFundTotalStakedFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsCommunityFundTotalStakedFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsCommunityFundTotalStakedRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsCommunityFundTotalStakedRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsCommunityFundTotalStakedFormat$inboundSchema.default(
      "json",
    ),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/** @internal */
export type GetApiV3MetricsCommunityFundTotalStakedRequest$Outbound = {
  end: number | null;
  format: string;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsCommunityFundTotalStakedRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsCommunityFundTotalStakedRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsCommunityFundTotalStakedRequest
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsCommunityFundTotalStakedFormat$outboundSchema
      .default("json"),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsCommunityFundTotalStakedRequest$ {
  /** @deprecated use `GetApiV3MetricsCommunityFundTotalStakedRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsCommunityFundTotalStakedRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsCommunityFundTotalStakedRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsCommunityFundTotalStakedRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsCommunityFundTotalStakedRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3MetricsCommunityFundTotalStakedRequest$Outbound;
}

export function getApiV3MetricsCommunityFundTotalStakedRequestToJSON(
  getApiV3MetricsCommunityFundTotalStakedRequest:
    GetApiV3MetricsCommunityFundTotalStakedRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsCommunityFundTotalStakedRequest$outboundSchema.parse(
      getApiV3MetricsCommunityFundTotalStakedRequest,
    ),
  );
}

export function getApiV3MetricsCommunityFundTotalStakedRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsCommunityFundTotalStakedRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsCommunityFundTotalStakedRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsCommunityFundTotalStakedRequest' from JSON`,
  );
}
